export const genericFields = `
  id
  area {
    value
    units
  }
  leased
  floor
  floors
  city {
    id
    name
  }
  location {
    id
    name
    fullName
  }
  hasMortgage
  price {
    value
    currency
  }
  company {
    id
    name
    targetType
  }
  paidDaily
  rooms
  hasBillOfSale
  hasRepair
  vipped
  featured
  updatedAt
  path
  photosCount
`;

export const profileItemStatusCounts = `
  PUBLISHED: items(state: PUBLISHED) {
    totalCount
  }

  VALIDATED_AND_AWAITING_PAYMENT: items(
    state: VALIDATED_AND_AWAITING_PAYMENT
  ) {
    totalCount
  }

  EXPIRED: items(state: EXPIRED) {
    totalCount
  }

  PENDING: items(state: PENDING) {
    totalCount
  }

  REJECTED: items(state: REJECTED) {
    totalCount
  }
`;
